// extracted by mini-css-extract-plugin
export default {"MigrationError-help":"MigrationError-help3-X-gINvpUqZ"};